document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector(".cards-track");
  const nextBtn = document.querySelector(".next-control");
  const prevBtn = document.querySelector(".prev-control");
  const cards = document.querySelectorAll(".card-item");
  const section = document.querySelector(".promo-section");

  if (!slider || cards.length === 0 || !section) return;

  if (window.innerWidth > 768) {
    let currentIndex = 0;
    const gap = 20;
    const cardWidth = cards[0].offsetWidth + gap;
    const visibleCards = Math.floor(section.offsetWidth / cardWidth);
    const totalCards = cards.length;

    // Total scrollable width
    const maxTranslate = (totalCards * cardWidth) - (visibleCards * cardWidth);
    const step = visibleCards * cardWidth;

    function updateSlider() {
      // Calculate target translate value
      let translateX = currentIndex * step;

      // Stop sliding beyond the end
      if (translateX > maxTranslate) translateX = maxTranslate;

      slider.style.transform = `translateX(-${translateX}px)`;

      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = translateX >= maxTranslate;
    }

    nextBtn.addEventListener("click", () => {
      const translateX = (currentIndex + 1) * step;
      if (translateX <= maxTranslate) {
        currentIndex++;
        updateSlider();
      }
    });

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });

    updateSlider();
  }
});
